import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RelatorioPrestadorRoutingModule } from './relatorio-prestador-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { NgbAlertModule, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxMaskModule } from 'ngx-mask';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { ReportUtil } from './meus-relatorios/util/reports.util';
import { MeusRelatoriosComponent } from './meus-relatorios/meus-relatorios.component';
import { ModalViewReportComponent } from './meus-relatorios/modal-view-report/modal-view-report.component';
import { RelatorioPrestadorComponent } from './relatorio-prestador.component';
import { FormularioRelatorioComponent } from './formulario-relatorio/formulario-relatorio.component';
import { FormServiceDateComponent } from './form-service-date/form-service-date.component';
import { FormServiceForecastComponent } from './form-service-forecast/form-service-forecast.component';
import { ModalAssignatureComponent } from './modal-assignature/modal-assignature.component';


@NgModule({
  declarations: [
    RelatorioPrestadorComponent,
    FormularioRelatorioComponent,
    MeusRelatoriosComponent,
    ModalViewReportComponent,
    FormServiceDateComponent,
    FormServiceForecastComponent,
    ModalAssignatureComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    NgbPaginationModule,
    NgbAlertModule,
    NgxMaskModule.forRoot(),
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    RelatorioPrestadorRoutingModule
  ],
  providers: [
    ReportUtil
  ],
  exports: [
    MeusRelatoriosComponent,
    ModalViewReportComponent
  ],
  entryComponents: [
    ModalViewReportComponent,
    ModalAssignatureComponent
  ]
})
export class RelatorioPrestadorModule { }
